module.exports = __webpack_public_path__ + "static/media/source-1.03de6950.svg";